import { useEffect, useRef } from 'react';

import WheelCanvas from '../WheelCanvas';
import { useWheelData } from '@lib/hooks/useWheelData';

const InteractionWheel = (props) => {
  const {
    winner,
    setting,
    wheelId,
    streamId,
    rosOptions,
    handleWheel,
    updateWinner,
    currentRosResult,
    startInteraction,
    getCommentsForInteractionWheel,
    setWinner,
    setWinnerInfo,
  } = useWheelData(s => ({
    winner: s.winner,
    setting: s.setting,
    wheelId: s.wheelId,
    streamId: s.streamId,
    rosOptions: s.rosOptions,
    handleWheel: s.handleWheel,
    updateWinner: s.updateWinner,
    currentRosResult: s.currentRosResult,
    startInteraction: s.startInteraction,
    getCommentsForInteractionWheel: s.getCommentsForInteractionWheel,
    setWinner: s.setWinner,
    setWinnerInfo: s.setWinnerInfo,
  }));

  const prevSettings = useRef({ setting, options: rosOptions });

  useEffect(() => {
    if (currentRosResult?.[0]?.options.length) return;

    getCommentsForInteractionWheel();

    if (winner === null) return;
    handleWheel({ interactionId: null });
  }, [winner, currentRosResult]);

  useEffect(() => {
    if (!props.showInstantCustomisationPopup) return;
    getCommentsForInteractionWheel();
  }, [props.showInstantCustomisationPopup, setting?.wheelInteractionId, setting?.wheelShowUser, startInteraction]);

  useEffect(() => {
    if (!wheelId) return;
    updateWinner();
  }, [wheelId]);

  useEffect(() => {
    if (!props.showInstantCustomisationPopup) {
      prevSettings.current = { setting, options: rosOptions };
    }
  }, [props.showInstantCustomisationPopup, setting, rosOptions]);

  useEffect(() => {
    if (!props.showInstantCustomisationPopup) return;

    const prev = prevSettings.current.setting;
    if (
      setting?.wheelInteractionId === prev?.wheelInteractionId &&
            setting?.enableWheelOptions === prev?.enableWheelOptions &&
            setting?.wheelShowUser === prev?.wheelShowUser &&
            setting?.enableKeyword === prev?.enableKeyword &&
            setting?.wheelKeyword === prev?.wheelKeyword
    ) {
      return;
    }

    setWinner(null);
    setWinnerInfo(null);
    handleWheel({ interactionId: null });
  }, [
    props.showInstantCustomisationPopup,
    setting?.wheelInteractionId,
    setting?.enableWheelOptions,
    setting?.wheelShowUser,
    setting?.enableKeyword,
    setting?.wheelKeyword
  ]);

  return (
    <>
      <WheelCanvas
        streamId={streamId}
        {...props}
      />
    </>
  );
};

export default InteractionWheel;
